import request from '../utils/request';
import { getLanguageUrl } from "@/utils/index";

/**
 * 项目列表接口和项目学习进度接口
 */
export function projectProgress(params) {
   return request.MainService({
      url: '/ddilearner/v2/user/learning/projectProgress',
      method: 'get',
      params: params
   })
}


/**
 * 控制测,学,练,考是否锁住
 */
export function learningpathItemsLock(params,learningPathMetaId) {
   return request.MainService({
      url: `/ddilearner/v2/user/learningpathes/itemsLock/${learningPathMetaId}`,
      method: 'get',
      params: params
   })
}

/**
 * 获取项目下课程列表或者散客列表
 */
export function coursesOrProjectCourses(params) {
   return request.MainService({
      url: `/sr/v2/coursesOrProjectCourses`,
      method: 'get',
      params: params
   })
}

/**
 * 查询用户学习凭证是否过期
 */
export function getTicketIsExpire(params) {
   return request.MainService({
      url: `/ddilearner/userTicket/verifyUserTicketIsExpire`,
      method: 'get',
      params: params
   })
}

// 用户点击播放视频
export function changPlayBroadcast(vid) {
   return request.LrsService({
       url: `/ddilearner/v2/broadcast?vid=${vid}`,
       method: 'get',
       data: {}
   });
}

// 自动弹出视频之后手动设置状态
export function changPlayPopup(projectId) {
  return request.LrsService({
    url: `/ddilearner/v2/vedio/popup/${projectId}`,
    method: 'post',
    data: {}
  });
}



// WEBPACK FOOTER //
// ./src/api/project.js